import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Context
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';

// Components
import { AuthCallback } from './components/auth';
import { PWAInstallPrompt } from './components/common';

// Pages
import {
  LandingPage,
  StoriesPage,
  SourcesPage,
  MethodologyPage,
  PrivacyPage,
  SharePage,
  SubscribePage,
  SubscribeSuccessPage,
  DigestPage,
  AdminPage,
  EnterprisePage,
  BookmarksPage
} from './pages';

// Mobile features
import { initMobileFeatures } from './mobile';

// App Router - handles auth callback detection
const AppRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id (synchronous - before render)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/stories" element={<StoriesPage />} />
      <Route path="/sources" element={<SourcesPage />} />
      <Route path="/methodology" element={<MethodologyPage />} />
      <Route path="/share/:shareId" element={<SharePage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/subscribe" element={<SubscribePage />} />
      <Route path="/subscribe/success" element={<SubscribeSuccessPage />} />
      <Route path="/digest" element={<DigestPage />} />
      <Route path="/enterprise" element={<EnterprisePage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/bookmarks" element={<BookmarksPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
};

// Main App
function App() {
  // Initialize mobile features on mount
  useEffect(() => {
    initMobileFeatures({
      onNotificationReceived: (notification) => {
        console.log('Notification received:', notification);
      },
      onNetworkChange: (status) => {
        console.log('Network status changed:', status);
      },
      onResume: () => {
        console.log('App resumed');
      }
    });
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <PWAInstallPrompt />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
